import { db } from '../../config/firebase'

const addDoc = ({ path, data }) =>
  db
    .collection(path)
    .add(data)
    .then((doc) => doc.id)

export default addDoc
